import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PageResult, PaginationParameters } from '../../types';
import { InputCodeAndCityZipCode, ZipCodeModel } from './types';
import { ErrorService } from '../../error';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ZipCodeApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly errorService: ErrorService,
  ) {}

  get = (): Observable<ZipCodeModel[]> => {
    let url = this.formatUrl([]);
    return this.httpClient.get<ZipCodeModel[]>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  getById = (id: string): Observable<ZipCodeModel> => {
    let parameters: string[];
    parameters = [id];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<ZipCodeModel>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  getByCodeAndCity = (
    inputCodeAndCityZipCode: InputCodeAndCityZipCode,
  ): Observable<ZipCodeModel> => {
    let parameters: string[];
    parameters = [
      'code',
      inputCodeAndCityZipCode.code,
      'city',
      inputCodeAndCityZipCode.city,
    ];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<ZipCodeModel>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  formatUrl = (parameters: string[]): string => {
    var url = environment.comparanooapiurl;
    url += environment.features.zipcodes.url;
    parameters.forEach((parameters) => {
      url += '/';
      url += parameters;
    });
    return url;
  };
}
